import { Box } from "@mui/material";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import LinkIcon from "@entrilia/shared/icons/LinkIcon";

interface Props {
  workbookFilter?: WorkbookFilter;
}
const ConditionBlockWorkbookFilter = ({ workbookFilter }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        "&:before": {
          content: '"("',
          color: "text.secondary",
        },
        "&:after": {
          content: '")"',
          color: "text.secondary",
        },
      }}
    >
      <LinkIcon fontSize="small" color="primary" />
      <TypographyTooltipEllipsis
        text={workbookFilter?.name ?? ""}
        typographyProps={{ color: "secondary", variant: "caption" }}
        tooltipProps={{
          disableInteractive: true,
        }}
      />
    </Box>
  );
};

export default ConditionBlockWorkbookFilter;
